if (!customElements.get('topbar-ticker')) {
  class TopbarTicker extends HTMLElement {
    constructor() {
      super();
      this.speed = Math.max(parseFloat(this.dataset.speed) || 50, 1);
      this.direction = this.dataset.direction === 'right' ? 'right' : 'left';
      this.original = this.querySelector('.topbar__ticker-content');
      this.track = null;
      this.mqMobile = window.matchMedia('(max-width: 1023.98px)');
      this._onChange = this.evaluate.bind(this);
      this._rafScheduled = false;
      this._onResize = () => {
        if (this._rafScheduled) return;
        this._rafScheduled = true;
        requestAnimationFrame(() => {
          this._rafScheduled = false;
          this.evaluate();
        });
      };
    }

    connectedCallback() {
      if (!this.original) return;
      this.mqMobile.addEventListener('change', this._onChange);
      this.resizeObserver = new ResizeObserver(this._onResize);
      this.resizeObserver.observe(this);
      this.evaluate();
    }

    disconnectedCallback() {
      this.mqMobile.removeEventListener('change', this._onChange);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    evaluate() {
      // Desktop: static, no animation.
      if (!this.mqMobile.matches) {
        this.teardown();
        return;
      }

      const containerWidth = this.clientWidth;
      const contentWidth = this.original.scrollWidth;

      // Fits: no need to scroll.
      if (!containerWidth || contentWidth <= containerWidth) {
        this.teardown();
        return;
      }

      this.build(containerWidth, contentWidth);
    }

    build(containerWidth, contentWidth) {
      if (!this.track) {
        this.track = document.createElement('span');
        this.track.className = 'topbar__ticker-track';
        this.original.parentNode.insertBefore(this.track, this.original);
        this.track.appendChild(this.original);
      } else {
        // Clear previous clones, keep the original (first child).
        while (this.track.children.length > 1) {
          this.track.removeChild(this.track.lastChild);
        }
      }

      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const oneCopy = contentWidth + gap;
      // Enough copies so the track always covers the viewport during the loop.
      const copies = Math.ceil(containerWidth / oneCopy) + 1;
      for (let i = 0; i < copies; i++) {
        const clone = this.original.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        this.track.appendChild(clone);
      }

      this.style.setProperty('--ticker-distance', `${oneCopy}px`);
      this.style.setProperty('--ticker-duration', `${oneCopy / this.speed}s`);
      this.style.setProperty('--ticker-direction', this.direction === 'right' ? 'reverse' : 'normal');
      this.classList.add('topbar__ticker--animating');
    }

    teardown() {
      this.classList.remove('topbar__ticker--animating');
      this.style.removeProperty('--ticker-distance');
      this.style.removeProperty('--ticker-duration');
      this.style.removeProperty('--ticker-direction');
      if (this.track) {
        while (this.track.children.length > 1) {
          this.track.removeChild(this.track.lastChild);
        }
        // Move original back out and drop the track wrapper.
        this.track.parentNode.insertBefore(this.original, this.track);
        this.track.remove();
        this.track = null;
      }
    }
  }

  customElements.define('topbar-ticker', TopbarTicker);
}
